<app-admin-page-header
  eyebrow="Contenu"
  title="Historique des événements"
  subtitle="Toutes les sorties organisées depuis la création du site, passées et à venir.">
  <a routerLink="/admin/evenements"
    class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
    Gérer les événements
  </a>
</app-admin-page-header>

<!-- Stats -->
<div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Total</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ evenements.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Événements depuis la création</p>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Affichés</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ filteredEvenements.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Selon le filtre actif</p>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Pages</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ currentPage }} / {{ totalPages }}</p>
    <p class="text-xs text-gray-500 mt-1">{{ pageSize }} événements par page</p>
  </div>
</div>

<!-- Table -->
<div class="bg-white rounded-xl border border-gray-200 shadow-sm">
  <div class="px-5 py-4 border-b border-gray-100 flex flex-col md:flex-row md:items-center gap-3 md:justify-between">
    <div class="relative w-full md:max-w-sm">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
      </div>
      <input type="search" [(ngModel)]="search" (ngModelChange)="onFilterChange()" placeholder="Rechercher par nom, lieu..."
        class="w-full pl-10 pr-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
      </div>

      <div class="flex flex-wrap gap-2">
        <select [(ngModel)]="anneeFilter" (ngModelChange)="onFilterChange()"
          class="px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
          <option value="toutes">Toutes les années</option>
          @for (a of annees; track a) {
            <option [value]="a">{{ a }}</option>
          }
        </select>

        <select [(ngModel)]="statutFilter" (ngModelChange)="onFilterChange()"
          class="px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
          <option value="tous">Tous les statuts</option>
          <option value="passes">Passés</option>
          <option value="a-venir">À venir</option>
        </select>

        <select [(ngModel)]="pageSize" (ngModelChange)="onFilterChange()"
          class="px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
          <option [ngValue]="10">10 / page</option>
          <option [ngValue]="15">15 / page</option>
          <option [ngValue]="25">25 / page</option>
          <option [ngValue]="50">50 / page</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm font-raleway">
        <thead class="bg-gray-50">
          <tr>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Date</th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Événement</th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Lieu</th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Statut</th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Visibilité</th>
            <th class="px-5 py-3"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (e of paginatedEvenements; track e) {
            <tr class="hover:bg-gray-50 transition-colors">
              <td class="px-5 py-3 whitespace-nowrap text-gray-700">
                {{ formatDate(e.dateDebut) }}
                <span class="block text-xs text-gray-400">{{ formatTime(e.dateDebut) }}</span>
              </td>
              <td class="px-5 py-3">
                @if (e.key) {
                  <a [routerLink]="['/agenda', e.key]" class="font-semibold text-gray-800 truncate max-w-xs block hover:text-primary hover:underline">{{ e.nom }}</a>
                }
                @if (!e.key) {
                  <p class="font-semibold text-gray-800 truncate max-w-xs">{{ e.nom }}</p>
                }
              </td>
              <td class="px-5 py-3 text-gray-600 truncate max-w-xs">{{ e.lieu || '—' }}</td>
              <td class="px-5 py-3">
                @if (isPasse(e)) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-[11px] font-semibold uppercase tracking-wider">
                    Passé
                  </span>
                }
                @if (!isPasse(e)) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[11px] font-semibold uppercase tracking-wider">
                    À venir
                  </span>
                }
              </td>
              <td class="px-5 py-3">
                @if (e.private) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 text-[11px] font-semibold uppercase tracking-wider">
                    Privé
                  </span>
                }
                @if (!e.private) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-[11px] font-semibold uppercase tracking-wider">
                    Public
                  </span>
                }
              </td>
              <td class="px-5 py-3 text-right">
                @if (e.key) {
                  <a [routerLink]="['/agenda', e.key]" aria-label="Voir l'événement"
                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:text-primary hover:bg-primary/10 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
                  </a>
                }
              </td>
            </tr>
          }
          @if (!loading && filteredEvenements.length === 0) {
            <tr>
              <td colspan="6" class="px-5 py-10 text-center text-sm text-gray-400">
                @if (search || anneeFilter !== 'toutes' || statutFilter !== 'tous') {
                  <span>Aucun événement ne correspond aux filtres.</span>
                }
                @if (!search && anneeFilter === 'toutes' && statutFilter === 'tous') {
                  <span>Aucun événement enregistré.</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    @if (filteredEvenements.length > 0) {
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 py-4 border-t border-gray-100">
        <p class="text-xs text-gray-500 font-raleway">
          Affichage de {{ rangeStart }} à {{ rangeEnd }} sur {{ filteredEvenements.length }} événements
        </p>
        <div class="flex items-center gap-1">
          <button type="button" (click)="previousPage()" [disabled]="currentPage === 1"
            class="px-3 py-1.5 text-sm font-raleway font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          Précédent
        </button>
        <span class="px-3 py-1.5 text-sm font-raleway text-gray-600">Page {{ currentPage }} / {{ totalPages }}</span>
        <button type="button" (click)="nextPage()" [disabled]="currentPage === totalPages"
          class="px-3 py-1.5 text-sm font-raleway font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          Suivant
        </button>
      </div>
    </div>
  }
</div>
